import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NotificationsFilterComponent } from '../notifications-filter/notifications-filter.component';
import { NotificationFilters } from 'app/shared/enums/notifications.enum';
import { TranslateModule } from '@ngx-translate/core';
import { NotificationPanelService } from '../notifications-panel.service';
import { NotificationsPanel } from '../notifications-panel.model';
import { ImpersonateService } from 'app/profile/impersonate-user/impersonate.service';

@Component({
  selector: 'app-notifications-header',
  standalone: true,
  imports: [FormsModule, CommonModule, NotificationsFilterComponent, TranslateModule],
  templateUrl: './notifications-header.component.html',
  styleUrl: './notifications-header.component.scss'
})

export class NotificationsHeaderComponent {
  activeFilters: NotificationFilters[] = [];
  hasActiveFilters = false; 
  notifications: NotificationsPanel[] = [];
  @Output() close = new EventEmitter<void>(); 
  @Output() markRead = new EventEmitter<void>();
  @Output() viewUnreadOnlyChange = new EventEmitter<boolean>();
  viewUnreadOnly = false;

  constructor(
    private notificationService: NotificationPanelService,
    public impersonateService: ImpersonateService
  ) { }

  onFiltersChanged(event: { types: NotificationFilters[] }): void {
    this.activeFilters = event.types;
    const params: { [key: string]: any } = { SkipCount: 0, TakeCount: 10 };
  
    if (this.activeFilters.length > 0) {
      params['actionType'] = this.activeFilters.join(','); 
    }
  
    this.notificationService.fetchNotifications(params);
  }

  markAllAsRead(): void {
    this.markRead.emit(); 
  }

  toggleViewUnreadOnly(): void {
    this.viewUnreadOnlyChange.emit(this.viewUnreadOnly);
  }

}
